var render, staticRenderFns
import script from "./MdPopover.vue?vue&type=script&lang=js"
export * from "./MdPopover.vue?vue&type=script&lang=js"
import style0 from "./MdPopover.vue?vue&type=style&index=0&id=72c738f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports